module.exports = __webpack_public_path__ + "static/img/icon3-5.a6c98b5a.png";